import CountryPage from '../../src/pages/CountryPage';

export default CountryPage;
